export default __webpack_public_path__ + "static/media/phone.5a09c64d.svg";